import { render, staticRenderFns } from "./GraduatesList.vue?vue&type=template&id=68581d42&"
import script from "./GraduatesList.vue?vue&type=script&lang=js&"
export * from "./GraduatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports